import { useMutation, useQuery } from '@tanstack/react-query';
import { getRecentPrompts } from '@/lib/actions/prompt';
import { useAuth } from '@/components/providers/AuthProvider';
import { generateForUseCase } from '@/lib/actions/replicate';

export const useGenerateForUseCase = () => {
  return useMutation({
    mutationFn: (data: {
      useCase: string;
      triggerWord: string;
      gender: string;
      modelUrl: string;
      modelId: string;
    }) => generateForUseCase(data),
  });
};

export const useFreeForm = () => {
  return useMutation({
    mutationFn: (data: {
      triggerWord: string;
      gender: string;
      modelUrl: string;
      modelId: string;
      freeText: string;
    }) =>
      generateForUseCase({
        useCase: 'freeForm',
        ...data,
      }),
  });
};

export const useRecentPrompts = ({ limit = 10 }: { limit?: number } = {}) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['prompts', 'recent', limit, user?.id],
    queryFn: () => getRecentPrompts({ limit }),
    enabled: !!user?.id,
  });
};
